import React from "react";
import ReactDOM from "react-dom";
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import Application from "./application";

const development = !process.env.NODE_ENV || process.env.NODE_ENV === "development";

if (!development) {
  Sentry.init({
    dsn: "https://721a7a2f94dd49678cce58f7b3c4f359@o50135.ingest.sentry.io/4504203876696065",
    tracesSampleRate: 0.25,
    integrations: [new BrowserTracing()]
  });
}

const onDOMReady = () => {
  const el = document.getElementById("root");
  document.removeEventListener("DOMContentLoaded", onDOMReady);
  if (el) {
    const component = React.createElement(Application);
    ReactDOM.render(component, el);
  }
};

document.addEventListener("DOMContentLoaded", onDOMReady);
